<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-4">
                        <az-input 
                            type="select"
                            placeholder="Selecione a Origem..."
                            :optionsList="[
                                {id: 'T', search: '[Outros]'},
                                {id: 'F', search: 'Fornecedor'}, 
                                {id: 'O', search: 'Operadoras'},
                                {id: 'M', search: 'Prestadores'},
                                {id: 'L', search: 'Unidades'},
                                {id: 'U', search: 'Usuários'},
                            ]"
                            optionsData="id"
                            v-model="filtro.origem">
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-primary" @click="load()">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                    <div class="col col-12 col-md-8">
                        <az-input
                            icon="fa-solid fa-search fa-fw"
                            placeholder="Pesquisar..."
                            v-model="filtro.search">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        {{ lista.length }}
                                    </span>
                                    <button type="button" class="btn btn-outline-primary" @click="incluir()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-2">
            <div class="indeterminate" v-if="$store.state.loading && lista.length"></div>
            <div class="determinate" v-else></div>
        </div>    

        <az-empty-state v-if="!lista.length" msg="Nenhum item encontrado." />

        <template v-else>

            <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                <tr>
                    <td class="text-nowrap">
                        <a href="#" @click.prevent="filtrar_texto(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                            <span class="badge badge-success mr-1">
                                {{ classe }}
                            </span>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="card carde mb-2" v-for="(item, iix) in lista" :key="iix">
                <div class="card-body p-3">
                    <div class="form-row">
                        <div class="col col-12 col-md-4">
                            <div>
                                <a href="#" @click.prevent="editar(item)" class="card-link" v-if="item.editavel">
                                    {{ item.nome }}
                                </a>
                                <span v-else>
                                    {{ item.nome }}
                                </span>
                            </div>
                            <div class="small">
                                <span class="mr-2" v-if="item.codigo">{{ item.codigo }}</span>
                                <span class="text-muted">#{{ item.id }}</span>
                            </div>
                            <div v-if="item.js_classes">
                                <a href="#" @click.prevent="filtrar_texto(js)" class="mr-1" v-for="(js, jix) in item.js_classes" :key="jix">
                                    <span class="badge badge-success mr-1" >
                                        {{ js }}
                                    </span>
                                </a>
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div v-for="(info, ifx) in item.info" :key="ifx">
                                <div v-show="info">
                                    <div v-if="!isNaN(info)">
                                        <i class="fa fa-phone fa-fw mr-1" aria-hidden="true"></i>
                                        {{ $util.formatMask(info, ( info && info.length == 11 ) ? 'cel' : 'tel') }}
                                    </div>
                                    <div v-else-if="info && info.indexOf('@') > 0">
                                        <i class="fa-regular fa-envelope fa-fw mr-1"></i>
                                        {{ info }}
                                    </div>
                                    <div v-else>
                                        {{ info }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div>{{ item.info_add }}</div>
                            <div class="small text-muted">{{ item.info_add_detalhe }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <pre v-if="false">{{ lista }}</pre>
        
        </template>

        <!-- Modal Outro Contato -->
        <div class="modal fade" id="contatoInfoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content" v-if="edicao">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Contato
                            <span class="badge badge-secondary ml-2" v-if="edicao && edicao.id_contato_info">#{{ edicao.id_contato_info }}</span>
                            <span v-if="edicao && !edicao.id_contato_info">(Novo)</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Nome"
                                    required
                                    :validate="validate"
                                    v-model="edicao.st_nome" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="e-mail"
                                    type="email"
                                    :validate="validate"
                                    v-model="edicao.st_email" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Telefone"
                                    type="fone"
                                    :validate="validate"
                                    v-model="edicao.st_telefone" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Celular"
                                    type="fone"
                                    :validate="validate"
                                    v-model="edicao.st_celular" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Observação"
                                    type="textarea"
                                    rows="4"
                                    :validate="validate"
                                    v-model="edicao.st_observacoes" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="contatoInfo" :id="edicao.id_contato_info" />
                        <az-submit color="outline-danger" @click="remover()" v-if="edicao.id_contato_info">Remover</az-submit>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ edicao.id_contato_info ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';

export default {
    data() { 
        return { 
            filtro: { 
                origem: "U", 
                search: "", 
            },
            dados: null,   
            edicao: null,
            validate: false, 
        };
    }, 

    components: { 
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton, 
    },

    computed: { 
        lista: function () { 
            if ( !this.dados )
                return [];

            let reg = this.$util.getregex(this.filtro.search);

            return this.dados.filter(item => !this.filtro.search || reg.test(JSON.stringify(item)));
        },

        lista_classes: function () { 
            if ( !this.dados )
                return [];

            return _.uniq(
                this.dados.flatMap(item => item.js_classes ? item.js_classes : []).sort()
            );
            
        }
    },

    methods: { 
        filtrar_texto(texto) { 
            if ( this.filtro.search == '"' + texto + '"' ) { 
                this.filtro.search = '';
            } else {
                this.filtro.search = '"' + texto + '"';
            }
        },

        editar(item) { 
            this.validate = false;
            this.edicao = _.cloneDeep(item.editavel);

            $('#contatoInfoModal').modal('show');
        },

        remover() { 
            if ( !confirm('Confirma remover este contato?') )
                return;
                
            this.$util.remover(this, { 
                service: 'contato_infos',
                func: 'destroy',
                dados: { 
                    ...this.edicao,
                    cadastro: true, 
                }, 
                modal: 'contatoInfoModal',
                reload: true, 
                toast: true, 
            });
        },

        incluir () { 
            this.validate = false;

            this.edicao = { 
                id_contato_info: null, 
                st_nome: "", 
                st_telefone: "",
                st_celular: "",
                st_email: "",
                st_observacoes: "", 
            };

            $('#contatoInfoModal').modal('show');
        },

        atualizar () { 
            this.filtro.origem = 'T';

            this.$util.atualizar(this, { 
                service: 'contato_infos',
                func: 'store',
                dados: {
                    ...this.edicao,
                    cadastro: true,
                },
                modal: 'contatoInfoModal',
                reload: true, 
                toast: true, 
            });
        },

        load() { 
            this.$util.load(this, { 
                service: 'telefones', 
                func: 'index', 
                parms: this.filtro, 
                loadTo: res => { 
                    this.dados = res;
                }
            });
        },
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Contatos", path: "/contatos" }
        ]);
    }
}
</script>